import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('Modal', {
  OPEN_FULLSCREEN_OVERLAY: null,
  CLOSE_FULLSCREEN_OVERLAY: null
});
